import client from './axiosInstance';

export const fetchClientsFilterList = async () => {
  return await client.get(`/clients/base/clients`);
};
